import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface WhatsAppBubbleSettings {
  enabled: boolean;
  link: string;
}

export const useWhatsAppBubble = () => {
  return useQuery({
    queryKey: ["whatsapp-bubble"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("app_settings")
        .select("value")
        .eq("key", "whatsapp_bubble")
        .maybeSingle();

      if (error) throw error;
      
      const settings = data?.value as unknown as WhatsAppBubbleSettings | undefined;
      return {
        enabled: settings?.enabled ?? false,
        link: settings?.link ?? "",
      };
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
